import { Heading } from '@chakra-ui/react';

const Title = ({ children }: { children: string }) => (
    <Heading color="gray.900" fontSize="32px" mb="16px">
        {children}
    </Heading>
);

export default Title;
